import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onClose: () => void
  onSubmit: () => Promise<void>
}

export const CancelConfirmationModal = ({ onClose, onSubmit }: Props) => {
  return (
    <Modal
      title={i18n.t('ats.candidates.messages.cancel_message.modal.title')}
      description={i18n.t('ats.candidates.messages.cancel_message.modal.description')}
      illustration="delete"
      onClose={onClose}
      onSubmit={onSubmit}
      footer={
        <Box flexDirection="row" gap="s16" flexGrow justifyContent="flexEnd">
          <Button type="secondary" onClick={onClose}>
            {i18n.t('ats.candidates.messages.cancel_message.modal.cancel')}
          </Button>
          <Button type="negative" submit>
            {i18n.t('ats.candidates.messages.cancel_message.modal.confirm')}
          </Button>
        </Box>
      }
    />
  )
}
